// @flow
import type { User } from '../types';

export default (opts: Object = {}): User => ({
  opk: '',
  apiUrl: '',
  email: '',
  emailSha: '',
  firstName: '',
  lastName: '',
  phone: '',
  isStaff: false,
  performanceMetricsEnabled: false,
  postalCode: '',
  hasDogs: false,
  isActiveServiceProvider: false,
  listsAllServices: false,
  shouldPromptForPets: false,
  slug: '',
  smallPhotoUrl: '',
  timeZone: '',
  unreadMessageCount: 0,
  showAdminToolbar: false,
  isSsuMigrated: false,
  ...opts,
});



// WEBPACK FOOTER //
// ../react-lib/src/factories/userFactory.js